import { type FC, useCallback, useEffect, useState } from 'react';

import { EBanners } from '../../constants/banners';
import { type IMapBannersProps } from '../../types/props';
import { LeadsContainer } from '../LeadsContainer';
import { RealtorReportBannerContainer } from '../RealtorReportBannerContainer';

import { useGetCurrentBanner } from './utils';

/**
 * Здесь предполагаю, что будет логика для баннеров для пакетов
 * https://conf.cian.tech/pages/viewpage.action?pageId=1299053455
 */
/**
 * Добавление новых баннеров:
 *  - добавляем в энаму (EBanners) баннеров новый баннер src/shared/constants/banners.ts
 *  - добавляем в константу мобильных размеров баннера (bannersMobileHeight) новый баннер src/shared/constants/banners.ts
 *  - добавляем в хук useGetCurrentBanner условия рендера нового баннера
 *  - добавляем условия установки высоты для мобильной версии баннера src/node/services/getBanner/getBanner.tsx
 */
export const MapBannersContainer: FC<IMapBannersProps> = props => {
  const [open, setOpen] = useState(false);
  const currentBanner = useGetCurrentBanner(props);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  /**
   * Массив deps пустой т.к. за одну сессию показываем только 1 тип баннера
   */
  useEffect(() => {
    if (currentBanner) {
      setOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  switch (currentBanner) {
    case EBanners.Leads:
      return <LeadsContainer open={open} onClose={handleClose} />;

    case EBanners.RealtorReport:
      return <RealtorReportBannerContainer open={open} onClose={handleClose} />;
  }

  return null;
};
